import { render, staticRenderFns } from "./AgendaDayGrigliaComponent.vue?vue&type=template&id=6e01d9af&scoped=true"
import script from "./AgendaDayGrigliaComponent.vue?vue&type=script&lang=js"
export * from "./AgendaDayGrigliaComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaDayGrigliaComponent.vue?vue&type=style&index=0&id=6e01d9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e01d9af",
  null
  
)

export default component.exports